/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TopBar_viewer = {|
  +isNotificationsEnabled: ?boolean;
  +isFavoritesEnabled: ?boolean;
  +isCartEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isNotificationsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NOTIFICATIONS",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NOTIFICATIONS\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"FAVORITES\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isCartEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CART",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"CART\"}"
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Likes_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
